<template>
  <div class="menu-container">
    <div class="container">
      <div class="menu">
        <div :class="menuToggleClass" @click="menuOpen = !menuOpen">
          <div class="bar" />
          <div class="bar" />
          <div class="bar" />
          <span>Menu</span>
        </div>
        <h1 class="logo"><em>Data</em>poort</h1>
        <!--                <h2 v-if="$route.name !== 'dashboard' && $route.meta.title !== undefined">{{ $route.meta.title }}</h2>-->
      </div>
      <div class="logout">
        <span v-if="!!greetUser">{{ greetUser }}</span>
        <a @click="logout" v-if="activeRoute.name !== 'login'" class="btn" style="color: white"
          >Uitloggen</a
        >
      </div>
    </div>
    <div :class="menuClass">
      <nav class="sidemenu" @click="menuOpen = false">
        <h2 class="logo">Menu</h2>
        <ul>
          <li
            v-for="route in rootMenuRoutes"
            :class="
              route.name === activeRoute.name || route.name === activeRoute.meta.parent
                ? 'active'
                : ''
            "
            :key="`${String(route.name)}`"
          >
            <router-link :to="{ name: route.name }">{{
              route.meta.menuTitle || route.meta.title
            }}</router-link>
            <ul
              v-if="
                (route.name === activeRoute.name || route.name === activeRoute.meta.parent) &&
                activeMenuChildRoutes
              "
            >
              <li
                v-for="child in activeMenuChildRoutes"
                :class="child.name === activeRoute.name ? 'active' : ''"
                :key="`${String(route.name)}_${String(child.name)}`"
              >
                <router-link :to="{ name: child.name }">{{
                  child.meta.menuTitle || child.meta.title
                }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user.ts'

const menuOpen = ref(false)
const router = useRouter()
const userStore = useUserStore()

const menuToggleClass = computed(() => {
  return 'menu-toggle' + (menuOpen.value ? ' menu-open' : '')
})
const menuClass = computed(() => {
  return 'sidemenu-container' + (menuOpen.value ? ' menu-open' : '')
})

const rootMenuRoutes = computed(() => {
  return router.getRoutes().filter((route) => {
    return (
      route.meta.menuItem === true &&
      (route.meta.parent ?? '') === '' &&
      (!route.meta.requiresRole ||
        (!!userStore.user &&
          !!userStore.user.roles &&
          userStore.user.roles.includes(route.meta.requiresRole)))
    )
  })
})

const activeMenuChildRoutes = computed(() => {
  const active = activeRoute.value.meta?.parent ?? activeRoute.value.name
  return router.getRoutes().filter((route) => {
    return (
      route.meta.menuItem === true &&
      (route.meta.parent ?? '') === active &&
      (!route.meta.requiresRole ||
        (!!userStore.user &&
          !!userStore.user.roles &&
          userStore.user.roles.includes(route.meta.requiresRole)))
    )
  })
})

const activeRoute = computed(() => {
  return router.currentRoute.value
})

const greetUser = computed(() => {
  let msg = null
  if (!!userStore.user) {
    const now = new Date().getHours()
    if (now < 6) {
      msg = 'Goedenacht'
    } else if (now < 12) {
      msg = 'Goedemorgen'
    } else if (now < 18) {
      msg = 'Goedemiddag'
    } else {
      msg = 'Goedenavond'
    }
    if (!!userStore.user.firstName) {
      msg += ' ' + userStore.user.firstName
    }
    if (!!userStore.user.lastName) {
      msg += ' ' + userStore.user.lastName
    }
  }
  return msg
})

const logout = () => {
  userStore.logout().then(() => router.push({ name: 'dashboard' }))
}
</script>
